import React, { useEffect, useState, useMemo } from 'react';
import { Row, Col, Card, Form } from 'reactstrap';
import {
    TextInput,
    SelectDropdown,
    CustomButton,
    SwitchInput,
    SwitchSelect,
    DateInput,
    TextArea,
    DatePicker,
} from '../../Components/Common/FormInputs';
import CardLayout from "../../Components/Common/CardLayout";
import PageLayout from "../../Components/Common/PageLayout";
import ErrorBoundary from "../../Components/Common/ErrorBoundary";
import useOrder from '../../hooks/useOrder';
import useFormvalidation from '../../hooks/validations/useFormvalidation';
import { OrderForm } from '../../hooks/validations/FormValidationRulesNew';
import Map from "./Map.js"
import useMaster from "../../hooks/useMaster";
import useGlobal from "../../hooks/useGlobal";
import Autocomplete from "react-google-autocomplete";
import Addproducts from './Addproducts';
import { getareaListApi } from "../../services/Apis";
import { useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { useDispatch } from 'react-redux';
import Commments from "./Comments"
import BottomTabs from './BottomTabs';
import { setsorting_data, setinitial_page } from '../../slices/globalslice';
import {
    setorderSelectedproducts
} from "../../slices/globalslice";
import {
    setorderamount, setcreditedamount, setordershippingcharges, setchargesfee, setorderbalanceamount, setprocessing_fee, setorderdonationfee, setorderdiscountcharges, setorderAddress, setordercustomeraddress
} from "../../slices/orderslice";
import { toast } from "react-toastify";
const CustomerForm = () => {
    const { slug } = useParams()
    const dispatch = useDispatch()
    const { postgetCustomerApi, postOrder, getemirateListApi, postOrderbyid, getnationsListApi, getGatewayPaymentListapi } = useOrder();
    const { isLoading, data } = postOrderbyid(slug)
    const { getAllCountries } = useMaster();
    const { getListType } = useGlobal();
    const [areadata, setAreadata] = useState([])
    const [customeraddresslist, setcustomeraddresslist] = useState([])
    const [previousorderdata, setpreviousorderdata] = useState([])
    const [previousticketsdata, setpreviousticketsdata] = useState([])
    const [emirateList, setEmirateList] = useState([]);
    const [addresserror, setaddresserror] = useState(false)
    const { isLoading: isLoadingCountry, data: countryData } = getAllCountries();
    const { isLoading: isLoadingNationality, data: nationalityData } = getnationsListApi();
    const [isAddingNewAddress, setIsAddingNewAddress] = useState(false);
    const masterdata = useSelector((state) => state.globalslice.masterdata || []);
    const updateddata = useSelector((state) => state.orderslice.updateddata || []);
    const orderamount = useSelector((state) => state.orderslice.orderamount || []);
    const orderAddress = useSelector((state) => state.orderslice.orderAddress);
    const ordercustomeraddress = useSelector((state) => state.orderslice.ordercustomeraddress);
    const profile_Details = useSelector(state => state.globalslice.profile_Details);
    const orderSelectedproducts = useSelector(
        (state) => state.globalslice.orderSelectedproducts
    );
    const order_fromdata = useMemo(() => (
        (masterdata || [])
            .filter(ele => ele.list_type === 'order_from')
            .map(item => ({ label: item.list_lable, value: item.list_value }))
    ), [masterdata]);
    const payment_methoddata = useMemo(() => (
        (masterdata || [])
            .filter(ele => ele.list_type === 'payment_method')
            .map(item => ({ label: item.list_lable, value: item.list_value }))
    ), [masterdata]);
    const timingOptions = useMemo(() => (
        (masterdata || [])
            .filter(ele => ele.list_type === 'avail_time')
            .map(item => ({ label: item.list_lable, value: item.list_value }))
    ), [masterdata]);

    const CountryDropdownData = [
        { label: 'None', value: 0 },
        ...(countryData?.data?.result?.map((item) => ({
            label: item.country_name,
            value: item.marketplace_id,
        })) || [])
    ];

    const nationalityOptions = [
        { label: 'None', value: 0 },
        ...(nationalityData?.data?.map((item) => ({
            label: item.country_name,
            value: item.id,
        })) || [])
    ];

    useEffect(() => {
        if (!isLoadingCountry) {
            const country_data = countryData?.data?.result;
            setValues({
                ...values,
                countryid: country_data[0]?.country_id
            })
        }
    }, [isLoadingCountry])
    const formValues = {
        contact: '',
        countryid: '',
        customer_name: '',
        order_from: '',
        payment_methodid: '',
        gway_paymentmethod: '',
        delivery_date: '',
        emirate: '',
        area: '',
        building: '',
        alt_contact: '',
        gway_transaction_id: '',
        nationality: '',
        gender: '',
        available_timing: '',
        same_day_delivery: 0,
        city: '',
        state: '',
        country: '',
        postcode: '',
        landmark: '',
        customer_id: '',
        address: orderAddress?.address,
        address_id: '',
        orderid: '',
        parent_orderid: '',
        order_vendor_id: '',
        order_ref_code: '',
        order_statusid: '',
        order_status: '',
        credit_amount: '',
    };
    const handleNext = async () => {
        if (updateddata?.length === 0 || updateddata?.every(p => p.rstatus === 0)) {
            toast.error("No products added.");
            return;
        }
        // const isDefaultGroup = profile_Details?.group?.some(g => g.id === 8);
        // if (!isDefaultGroup) {
        //     const outOfStockProduct = updateddata.find(
        //         (p) => p.rstatus !== 0 && p.inventory === 0
        //     );

        //     if (outOfStockProduct) {
        //         toast.error("Product is out of stock.");
        //         return;
        //     }
        // }
        if (orderAddress?.address == "") {
            setaddresserror(true)
            return;
        }
        const {
            contact,
            countryid,
            customer_name,
            order_from,
            payment_methodid,
            gway_paymentmethod,
            delivery_date,
            emirate,
            area,
            building,
            alt_contact,
            gway_transaction_id,
            nationality,
            gender,
            available_timing,
            same_day_delivery,
            city,
            customer_id,
            state,
            country,
            postcode,
            landmark,
            address,
            address_id,
            orderid,
            vendor_id,
            orderstatus,
            parent_orderid,
            order_vendor_id,
            order_ref_code,
            order_statusid,
            order_status,
            credit_amount
        } = values;

        const payload = {
            orderid: slug ? orderid : 0,
            ...(slug && {
                parent_orderid: parent_orderid,
                order_vendor_id: order_vendor_id,
                order_ref_code: order_ref_code,
                order_statusid: order_statusid,
                order_status: order_status,

            }),
            credit_amount: slug ? credit_amount : 0,
            vendor_id: 0,
            country_id: countryid,
            itemcount: updateddata?.length,
            discount_amount: orderamount.discount,
            donation_fee: orderamount.donation_fee,
            balance_amount: orderamount.balance_amount,
            // charge: orderamount.chargesfee,
            total_amount: orderamount.total,
            sub_total: orderamount.subtotal,
            shipping_charges: orderamount.shippingCharge,
            processing_fee: orderamount.processing_fee,
            orderstatus: 1,
            channel: order_from,
            payment_methodid: payment_methodid,
            gway_paymentmethod: payment_methodid == 2 ? gway_paymentmethod : 0,
            delivery_date: delivery_date,
            available_time: available_timing,
            same_day_delivery: same_day_delivery,
            gway_transaction_id: payment_methodid == 2 ? gway_transaction_id : "",
            tax_amount: orderamount.vatAmount,
            customer_details: {
                customer_id: customer_id == "" ? 0 : customer_id,
                first_name: customer_name,
                gender: gender,
                nationality: nationality,
                mobile: contact,
                alternative_mobile: alt_contact,
                emirate: emirate,
                area: area,
                latitude: orderAddress?.latitude,
                longitude: orderAddress?.longitude,
                address: orderAddress?.address,
                address2: "",
                city: city,
                building_name: building,
                customer_addressid: address_id == "" ? 0 : address_id
            },
            product_details: updateddata.map(p => ({
                ...p,
                rstatus: p.status === "delete" ? 0 : 1,
            }))
        };

        if (slug) {
            payload.id = slug;
        }

        postOrder.mutate(payload, {
            onSuccess: (response) => {
                dispatch(setinitial_page(1));
                dispatch(setorderSelectedproducts([]));
                dispatch(setorderamount());
                dispatch(setcreditedamount(""));
                dispatch(setorderdiscountcharges(0));
                dispatch(setorderdonationfee(0));
                dispatch(setprocessing_fee(0));

                // dispatch(setchargesfee(0));
                dispatch(setordershippingcharges(0));
                dispatch(setorderbalanceamount(0));
                setaddresserror(false)
            },
            onError: (error) => {
                console.error("Order creation failed", error);
                // Optional: show error toast
                // toast.error("Failed to create order");
            }
        });


    };

    useEffect(() => {
        if (!slug) {
            dispatch(setorderSelectedproducts([]))
            dispatch(setordershippingcharges(0));
            dispatch(setorderbalanceamount(0));
        }
    }, [])

    const {
        handleChange,
        handleSubmit,
        errors,
        values,
        setValues,
        handleToggleChange,
    } = useFormvalidation(handleNext, OrderForm, formValues);


    // useEffect(() => {
    //     if (values.countryid) {
    //       const { isLoading: isLoadingemirate, data: emirateData } = getemirateListApi();
    //     }
    // }, [values.countryid]);
    const { isLoading: isLoadingemirate, data: emirateData } = getemirateListApi(values.countryid);
    const EmirateDataDropdownData = [
        { label: 'None', value: 0 },
        ...(emirateData?.data?.map((item) => ({
            label: item.emirate,
            value: item.id,
        })) || [])
    ];
    const { isLoading: isLoadingGatewayPayment, data: GatewayPaymentListData } = getGatewayPaymentListapi();

    const GatewayPaymentListDataoption = [
        { label: 'None', value: 0 },
        ...(GatewayPaymentListData?.data
            ?.filter((item) => item.country_id === values.countryid)
            .map((item) => ({
                label: item.name,
                value: item.id,
            })) || [])
    ];

    const selectedCountry = countryData?.data?.result?.find(
        (ele) => ele.country_id === values.countryid
    );
    const fetchAreaList = async () => {
        if (values?.emirate && values.emirate !== "") {
            try {
                const response = await getareaListApi(values.emirate);
                setAreadata(response.data)
                // Do something with the response here
            } catch (error) {
            }
        }
    };
    useEffect(() => {
        fetchAreaList();
    }, [values?.emirate]);
    const AreaDropdownData = [{ label: 'None', value: 0 }, ...areadata?.map((item) => ({
        label: `${item.name} `,
        value: item.id,
    })) || []];
    const genderOptions = [
        { label: "Male", value: 1 },
        { label: "Female", value: 2 }
    ];

    useEffect(() => {
        if (!isLoading && slug) {
            dispatch(setorderSelectedproducts(data?.data[0]?.product_details))
            setpreviousticketsdata(data?.data[0])
            dispatch(setordershippingcharges(data?.data[0]?.shipping_charges));
            dispatch(setorderbalanceamount(data?.data[0]?.balance_amount));
            dispatch(setorderdiscountcharges(data?.data[0]?.discount_amount));
            dispatch(setprocessing_fee(data?.data[0]?.processing_fee));
            // dispatch(setchargesfee(data?.data[0]?.charges));
            dispatch(setorderdonationfee(data?.data[0]?.donation_fee));
            dispatch(setcreditedamount(data?.data[0]?.credit_amount));
            setpreviousorderdata(data)
            dispatch(setorderAddress({
                address: data?.data[0]?.customer_details?.address,
                latitude: data?.data[0]?.customer_details?.latitude,
                longitude: data?.data[0]?.customer_details?.longitude
            }));
            setValues({
                customer_name: data?.data[0]?.customer_details?.first_name || '',
                orderid: data?.data[0]?.orderid,
                parent_orderid: data?.data[0]?.parent_orderid,
                order_vendor_id: data?.data[0]?.order_vendor_id,
                order_ref_code: data?.data[0]?.order_ref_code,
                countryid: data?.data[0]?.country_id,
                credit_amount: data?.data[0]?.credit_amount,
                contact: data?.data[0]?.customer_details?.mobile,
                order_from: data?.data[0]?.channel || '',
                payment_methodid: data?.data[0]?.payment_methodid,
                gway_paymentmethod: data?.data[0]?.gway_paymentmethod,
                delivery_date: data?.data[0]?.delivery_date || '',
                emirate: data?.data[0]?.customer_details?.emirate || '',
                area: data?.data[0]?.customer_details?.area || '',
                building: data?.data?.[0]?.customer_details?.building_name || '',
                alt_contact: data?.data[0]?.customer_details?.alternative_mobile || '',
                gway_transaction_id: data?.data[0]?.gway_transaction_id || '',
                nationality: data?.data[0]?.customer_details?.nationality || '',
                gender: data?.data[0]?.customer_details?.gender || '',
                city: data?.data[0]?.customer_details?.city,
                address: data?.data[0]?.customer_details?.address,
                customer_id: data?.data[0]?.customer_details?.customer_id,
                address_id: data?.data[0]?.customer_details?.customer_addressid,
                same_day_delivery: data?.data[0]?.same_day_delivery,
                available_timing: data?.data[0]?.available_time,
                order_status: data?.data[0]?.order_status,
                order_statusid: data?.data[0]?.order_statusid
            })
        }
    }, [isLoading, data])

    useEffect(() => {
        if (values?.contact?.length === selectedCountry?.number_count && !slug) {
            postgetCustomerApi.mutate(
                {
                    "country_id": values.countryid,
                    "number": values.contact
                },
                {
                    onSuccess: (res) => {
                        const data = res?.data;
                        setpreviousorderdata(data)
                        setcustomeraddresslist(data?.address)
                        dispatch(setordercustomeraddress(data?.address))
                        dispatch(setorderAddress({
                            address: data?.address[0]?.address,
                            latitude: data?.address[0]?.latitude,
                            longitude: data?.address[0]?.longitude

                        }));
                        setValues((prev) => ({
                            ...prev,
                            customer_name: data?.customer_details?.first_name || '',
                            emirate: data?.address[0]?.emirate || '',
                            area: data?.address[0]?.area || '',
                            building: data?.address[0]?.building_name || '',
                            alt_contact: data?.customer_details?.alt_contact || '',
                            nationality: data?.customer_details?.nationality || '',
                            gender: data?.customer_details?.gender,
                            city: data?.address[0]?.city,
                            state: data?.address[0]?.state,
                            address: data?.address[0]?.address,
                            customer_id: data?.customer_details?.customer_id,
                            address_id: data?.address[0]?.address_id
                        }));
                    },
                });
        }
    }, [values.contact]);
    return (
        <>
            <Form onSubmit={handleSubmit}>
                <PageLayout >
                    <CardLayout heading="Order">
                        <ErrorBoundary fallback={<div>Oops! Something went wrong loading the page.</div>}>
                            <Row>
                                <Col lg={6}>
                                    <Row>
                                        <Col lg={6}>
                                            <SelectDropdown
                                                label="Country"
                                                options_data={CountryDropdownData}
                                                name="countryid"
                                                isrequired
                                                setValues={setValues}
                                                values={values}
                                                value={values.countryid}
                                                isMultiple={false}
                                                error_msg={errors.countryid}
                                                isDisabled={slug ? true : false}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <SelectDropdown
                                                label="Order Source"
                                                options_data={order_fromdata}
                                                name={'order_from'}
                                                isrequired
                                                isMultiple={false}
                                                setValues={setValues}
                                                values={values}
                                                value={values.order_from}
                                                error_msg={errors.order_from}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <TextInput
                                                allowOnlyNumbers
                                                label="Contact Number"
                                                name="contact"
                                                placeholder="Enter Contact Number"
                                                value={values.contact}
                                                onChange={handleChange}
                                                prefix={selectedCountry?.country_phone_code}
                                                isrequired
                                                invalid={!!errors.contact}
                                                maxlength={selectedCountry?.number_count}
                                                error_msg={errors.contact}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <TextInput
                                                input_type={1}
                                                name="customer_name"
                                                placeholder="Enter First name"
                                                label="Customer Name"
                                                isrequired
                                                value={values.customer_name}
                                                onChange={handleChange}
                                                invalid={!!errors.customer_name}
                                                error_msg={errors.customer_name}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <SelectDropdown
                                                label="Nationality"
                                                options_data={nationalityOptions}
                                                name={'nationality'}
                                                isMultiple={false}
                                                isrequired
                                                setValues={setValues}
                                                values={values}
                                                value={values.nationality}
                                                error_msg={errors.nationality}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <SelectDropdown
                                                label="Gender"
                                                options_data={genderOptions}
                                                name={'gender'}
                                                isMultiple={false}
                                                isrequired
                                                setValues={setValues}
                                                values={values}
                                                value={values.gender}
                                                error_msg={errors.gender}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <SelectDropdown
                                                label="Emirate"
                                                options_data={EmirateDataDropdownData}
                                                name={'emirate'}
                                                isrequired
                                                isMultiple={false}
                                                setValues={setValues}
                                                values={values}
                                                value={values.emirate}
                                                error_msg={errors.emirate}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <SelectDropdown
                                                label="Select Area"
                                                options_data={AreaDropdownData}
                                                name={'area'}
                                                isMultiple={false}
                                                setValues={setValues}
                                                values={values}
                                                value={values.area}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <DatePicker
                                                label={'Delivery Date'}
                                                mode="single"
                                                enableTime={true}
                                                value={values.delivery_date}
                                                placeholder="Select Date"
                                                name={'delivery_date'}
                                                setValues={setValues}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <SelectDropdown
                                                label="Available Timing"
                                                options_data={timingOptions}
                                                name={'available_timing'}
                                                isMultiple={false}
                                                setValues={setValues}
                                                values={values}

                                                value={values.available_timing}
                                                error_msg={errors.available_timing}
                                            />
                                        </Col>

                                        <Col lg={6}>
                                            <TextInput
                                                input_type={1}
                                                name="building"
                                                placeholder="Enter Building/Flat No."
                                                label="Building/Flat No."
                                                value={values.building}
                                                onChange={handleChange}
                                            // invalid={!!errors.building}
                                            // error_msg={errors.building}

                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <TextInput
                                                allowOnlyNumbers
                                                input_type={1}
                                                name="alt_contact"
                                                placeholder="Enter Alternative No."
                                                label="Alternative No."
                                                value={values.alt_contact}
                                                onChange={handleChange}
                                                invalid={!!errors.alt_contact}
                                                error_msg={errors.alt_contact}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <SelectDropdown
                                                label="Payment Method"
                                                options_data={payment_methoddata}
                                                name={'payment_methodid'}
                                                isrequired
                                                isMultiple={false}
                                                setValues={setValues}
                                                values={values}
                                                value={values.payment_methodid}
                                                error_msg={errors.payment_methodid}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <SwitchSelect
                                                label="Same day delivery"
                                                name="same_day_delivery"
                                                handleToggleChange={handleToggleChange}
                                                checked={values.same_day_delivery}
                                            />
                                        </Col>
                                        {values.payment_methodid === 1 && (
                                            <>
                                                <Col lg={6}>
                                                    <SelectDropdown
                                                        label="Payment Type"
                                                        options_data={GatewayPaymentListDataoption}
                                                        name={'gway_paymentmethod'}
                                                        isMultiple={false}
                                                        setValues={setValues}
                                                        values={values}
                                                        value={values.gway_paymentmethod}
                                                        error_msg={errors.gway_paymentmethod}
                                                    />
                                                </Col>

                                                <Col lg={6}>
                                                    <TextInput
                                                        allowOnlyNumbers
                                                        input_type={1}
                                                        name="gway_transaction_id"
                                                        placeholder="Enter Transaction id"
                                                        label="Transaction Id"
                                                        value={values.gway_transaction_id}
                                                        onChange={handleChange}
                                                        invalid={!!errors.gway_transaction_id}
                                                        error_msg={errors.gway_transaction_id}
                                                    />
                                                </Col>
                                            </>
                                        )}

                                    </Row>
                                </Col>
                                <Col lg={6}>
                                    <Map error={addresserror && "Address is Requied"} />
                                    <Col lg={12}>

                                        {customeraddresslist && customeraddresslist.length > 0 && (
                                            <>
                                                {customeraddresslist.map((addr) => (
                                                    <div key={addr.address_id} className="form-check mb-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="customer_address"
                                                            id={`address-${addr.address_id}`}
                                                            value={addr.address_id}
                                                            checked={values.address_id === addr.address_id && !isAddingNewAddress}
                                                            onChange={() => {
                                                                setIsAddingNewAddress(false);
                                                                setValues(prev => ({
                                                                    ...prev,
                                                                    address_id: addr.address_id,
                                                                    emirate: addr.emirate,
                                                                    area: addr.area,
                                                                    building: addr.building_name,
                                                                    city: addr.city,
                                                                    address: addr.address,
                                                                }));
                                                                dispatch(setorderAddress({
                                                                    address: addr.address,
                                                                    latitude: addr.latitude,
                                                                    longitude: addr.longitude,
                                                                }));
                                                            }}
                                                        />
                                                        <label className="form-check-label" htmlFor={`address-${addr.address_id}`}>
                                                            {addr.address} {addr.building_name && `- ${addr.building_name}`}
                                                        </label>
                                                    </div>
                                                ))}

                                                {/* Add New Address Option */}
                                                {/* <div className="form-check mb-2">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="customer_address"
                                                        id="address-new"
                                                        value="new"
                                                        checked={isAddingNewAddress}
                                                        onChange={() => {
                                                            setIsAddingNewAddress(true);
                                                            // Clear address-related values to allow new entry
                                                            setValues(prev => ({
                                                                ...prev,
                                                                address_id: 0,
                                                                emirate: '',
                                                                area: '',
                                                                building: '',
                                                                city: '',
                                                                address: '',
                                                            }));
                                                            dispatch(setorderAddress({
                                                                address: '',
                                                                latitude: '',
                                                                longitude: '',
                                                            }));
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor="address-new">
                                                        Add New Address
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                    </Col>

                                </Col>

                            </Row>
                        </ErrorBoundary>
                    </CardLayout>
                    <Card>
                        <Addproducts countryid={values.countryid} areaid={values.area} countryData={countryData?.data?.result} />
                    </Card>
                    <Row>
                        <Col lg={slug ? 8 : 12}>
                            <BottomTabs previousorderdata={previousorderdata} previousticketsdata={previousticketsdata} showtickets={true} OrderHistorydata={previousticketsdata} cartid={data?.data[0]?.customer_details?.customer_id} />
                        </Col>
                        {
                            slug &&
                            <Col lg={4}>
                                <CardLayout heading={'Comments'}>
                                    <Commments orderid={values.orderid} />

                                </CardLayout>

                            </Col>
                        }
                    </Row>
                    <Card  >
                        <div className="d-flex justify-content-end mt-3 mb-3 me-5">
                            <CustomButton label="Submit" handleSubmit={handleSubmit} loading={postOrder?.isPending} />
                        </div>
                    </Card>
                </PageLayout>
            </Form>
        </>
    );
};

export default React.memo(CustomerForm);
